import { LoyaltyDomainSpecificErrorCode, NotificationType } from '@vista-digital/occ-domain';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
const getNotificationId = (context) => {
    return getIdForComponentNotification('member-sign-in-form', NotificationType.Error, context);
};
export const getNotificationDetailsForError = (displayText, error) => {
    switch (error.errorCode) {
        case LoyaltyDomainSpecificErrorCode.InvalidCredentials:
            return {
                id: getNotificationId('invalid-credentials'),
                messages: [displayText.errorApiIncorrectSignInCredentialsMessage]
            };
        case LoyaltyDomainSpecificErrorCode.MemberLocked:
            return {
                id: getNotificationId('member-locked'),
                messages: [displayText.errorApiMemberLockedMessage]
            };
        default:
            return {
                id: getNotificationId('failed-to-submit'),
                messages: [displayText.errorApiFailedSignInMessage]
            };
    }
};
//# sourceMappingURL=get-notification-details-for-error.js.map